
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#d0efec","stroke":"#234652","stroke-linecap":"round","d":"M6.969 16.491H4.092a3.592 3.592 0 0 1-1.926-6.625 4.04 4.04 0 0 1 4.36-4.5 4.974 4.974 0 0 1 9.62-1.07 4.04 4.04 0 0 1 5.02 5.237 3.594 3.594 0 0 1-1.258 6.958H17.51"}}),_c('path',{attrs:{"fill":"#fff","stroke":"#234652","d":"M13.504 17.853V16.11l2.06-1.243c.586-.354.936-.999.936-1.685v-3.153c0-.687-.35-1.332-.936-1.685l-2.612-1.577a1.84 1.84 0 0 0-1.904 0L8.436 8.343a1.96 1.96 0 0 0-.936 1.685v3.153c0 .686.35 1.331.936 1.685l2.068 1.248v6.16c0 .963 1.084 1.61 1.906.983l-.303-.398.303.398.612-.466c.307-.235.482-.602.482-.984v-.377c.124-.05.255-.116.373-.202.28-.204.481-.519.481-.962v-1.243c0-.44-.2-.75-.471-.955-.12-.09-.256-.16-.383-.215Z"}}),_c('path',{attrs:{"fill":"#fff","stroke":"#234652","d":"M12 12.104c.807 0 1.424-.677 1.424-1.465 0-.789-.617-1.466-1.424-1.466s-1.424.677-1.424 1.466.617 1.465 1.424 1.465Z"}})])
          )
        }
      }
    